  {#await searchPromise}
    <nav class="suggestions {combo ? "combo" : ""}">
      <a
        href="/#/"
        class="suggestions-item">
        Searching...
      </a>
    </nav>
  {:then suggestions}
    {#if (suggestions && suggestions.length > 0)}
      <nav class="suggestions {combo ? "combo" : ""}">
        {#each suggestions as suggestion}
          <a
            href="/#/"
            class="suggestions-item"
            on:click|stopPropagation|preventDefault={() => goTo(suggestion)}>
            {capitalize(suggestion.name)}
          </a>
        {/each}
      </nav>
    {:else if (suggestions && suggestions.length === 0)}
      <nav class="suggestions {combo ? "combo" : ""}">
        <a
          href="/#/"
          class="suggestions-item">
          No Results
        </a>
      </nav>
    {/if}
  {/await}
  {#if isNotAOI && !searchPromise}
    <nav class="suggestions no-scroll {combo ? "combo" : ""}">
      <div class="suggestions-not-aoi">
        <h4>Your Suburb Is Not in the Floodplain</h4>
        <p>Please enter a suburb within the Hawkesbury-Nepean floodplain. For other locations consult your local council about your flood risk or visit <a target="_blank" href="//www.ses.nsw.gov.au/disaster-tabs-header/flood">NSW SES flood information</a>.</p>
      </div>
    </nav>
  {/if}

<script>
import { createEventDispatcher } from "svelte/internal";
import utils from "../../../utils";
export let searchPromise = undefined;
export let combo = false;
export let isNotAOI = false;
let capitalize = utils.capitalize;
const dispatch = createEventDispatcher();
const goTo = (val) => {
    dispatch("goto", val);
};
</script>


<style>.suggestions{background:#fff;display:flex;flex-direction:column;border-radius:0 0 .625rem .6rem;border:1px solid #f08403;max-height:220px;overflow:auto;min-height:2.4rem;top:0;width:100%;position:absolute;z-index:2}.suggestions.no-scroll{overflow:hidden}.suggestions-item{padding:7px 14px;color:#363636;font-size:.875rem;line-height:31px}.suggestions-item:focus,.suggestions-item:hover{background:#efefef}.suggestions-not-aoi{padding:14px 16px}.suggestions-not-aoi h4{color:#000;font-size:.8125rem;font-weight:700;line-height:18px;text-transform:uppercase;text-align:center;padding:14px 0;border-bottom:1px solid #d9d9d9}.suggestions-not-aoi p{color:#d70000;font-size:14px;line-height:22px;padding:14px 10px 14px 18px}.suggestions-not-aoi p a{text-decoration:underline}.suggestions.combo{border-radius:10px;box-shadow:0 1px 2px 0 rgba(0,0,0,.07);position:relative}.suggestions.combo .suggestions-item{padding:7px 15px}</style>
